import type { Decision } from "../../../api/access/decisions";
import type { PermittedAction } from "../../../api/permittedActions";
import { projectDecision, type ProjectContextValue } from "../../../projects/projectContext";

/**
 * The project action that lets someone make and publish releases (F17): the groups that hold
 * Releases (GS-2). Every place that offers Release… or publishing asks for this one action; the
 * server asks module A again when the release step runs.
 */
export const RELEASE_ACTION: PermittedAction = "make_release";

/** The decision every release entry point shows (SOT-02): releasing in `projectId`, known for the chosen project only. */
export function releaseDecision(projects: ProjectContextValue, projectId: string): Decision {
  return projectDecision(projects, projectId, RELEASE_ACTION);
}
